import { Grid2 } from "@mui/material";
import type { ComponentProps } from "react";

type BorderedGridProps = ComponentProps<typeof Grid2>;

export const BorderedGrid: React.FC<BorderedGridProps> = (props) => {
  return (
    <Grid2
      container
      sx={{
        borderLeft: "1px solid #E4E5E5",
        borderTop: "1px solid #E4E5E5",
        borderRadius: "8px",
        fontSize: "12px",
        color: "grey.700",
        textAlign: "center",
      }}
      {...props}
    />
  );
};

export const BorderedGridItem: React.FC<BorderedGridProps> = (props) => {
  return (
    <Grid2
      px={1}
      py={0.75}
      borderRight="1px solid #E4E5E5"
      borderBottom="1px solid #E4E5E5"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    />
  );
};
